import MutateTrigger from "./MutateTrigger";

export default MutateTrigger